import { render, staticRenderFns } from "./AddProjectPop.vue?vue&type=template&id=0b1dd1f5&"
import script from "./AddProjectPop.vue?vue&type=script&lang=js&"
export * from "./AddProjectPop.vue?vue&type=script&lang=js&"
import style0 from "./AddProjectPop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports